import { Component, signal, OnInit, inject } from '@angular/core';
import { RouterOutlet, ChildrenOutletContexts } from '@angular/router';
import { slideInAnimation } from './animations';
import { NotificationComponent } from './components/notification/notification.component';
import { SocketService } from './services/socket.service';
import { ChatService } from './services/chat.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NotificationComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
  animations: [slideInAnimation]
})
export class App implements OnInit {
  protected readonly title = signal('edu-vweb');
  private authService = inject(AuthService);

  constructor(
    private contexts: ChildrenOutletContexts,
    private socketService: SocketService,
    private chatService: ChatService
  ) {}

  ngOnInit(): void {
    // Conectar Socket.io al iniciar la app (si hay token guardado)
    const token = this.authService.getToken();
    if (token) {
      console.log('🚀 App iniciada, conectando socket...');
      this.socketService.conectar(token);
      
      // Unirse a todas las conversaciones una vez conectado
      this.socketService.conectado$.subscribe(conectado => {
        if (conectado) {
          console.log('✅ Socket conectado desde App, uniéndose a conversaciones...');
          this.chatService.unirseAConversaciones();
          this.chatService.cargarConversaciones();
        }
      });
    } else {
      console.log('⚠️ No hay token, no se conecta el socket');
    }
  }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }
}
